<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">选择药品</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">
                <div>
                    <!-- <el-row style="margin:10px 0">
                        <el-input  placeholder="请输入挂号编号" v-model="serialNumber" clearable style="margin:0 10px 0 0;width:250px"></el-input>
                        <el-button type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </el-row> -->
                    <div style="margin-bottom:10px">
                        <el-input  placeholder="请输入药品名称" v-model="name" clearable style="margin-right:5px;width:200px"></el-input>
                        <el-select v-model="waresTypeDrugCode" placeholder="请选择药品类型" clearable style="margin:0 5px;width:200px;">
                            <el-option
                                    v-for="item in WaresTypeDrugCodeValue"
                                    :key="item.waresTypeDrugCode"
                                    :label="item.name"
                                    :value="item.waresTypeDrugCode">
                            </el-option>
                        </el-select>
                        <el-button style="margin-left:5px" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                    <div style="clear: both;"></div>
                </div>
                 <template>
                <el-table :data="tableData" height="600" border>

                    <el-table-column prop="name" label="药品名称"></el-table-column>

                    <el-table-column prop="price" label="药品单价（元）"></el-table-column>

                    <el-table-column prop="supplierDrugName" label="供应商"></el-table-column>

                    <el-table-column prop="waresTypeDrugName" label="药品类型"></el-table-column>

                    <el-table-column prop="stock" label="库存"></el-table-column>
                    
                    <el-table-column label="操作" width="150">
                        <template slot-scope="scope">
                            <el-button type="primary" v-if="scope.row.add==0" size="small" @click.native.prevent="handleAdd(scope.$index, scope.row)">添加</el-button>
                            <el-button type="success" v-else size="small" >已添加</el-button>
                        </template>
                    </el-table-column>

                </el-table>
                <div style="text-align: left;background-color: #fff;padding: 10px;">
                    <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                    <div style="float: left;">
                        <el-pagination
                            background
                            layout="prev, pager, next"
                            :total="totalItems"
                            :page-size="20"
                            @current-change="current_change">
                        </el-pagination>
                    </div>
                    <div style="clear: both;"></div>
                </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Add",
        data() {
            return {

                loading: false,
                pageSize:20,
                currentPage:1,
                showModalAdd:false,
                tableData:[],
                waresList:[],
                codeList:[],
                WaresTypeDrugCodeValue:"",
                waresTypeDrugCode:"",
                totalItems: 0,
                th:0,
                name:'',
            }
        },
        methods: {
            init(data){
                this.codeList=data
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"WaresTypeDrug/List",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            this.WaresTypeDrugCodeValue = response.data.data;
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
                this.getList()
            },
            closeSelf() {
                this.$emit("close");
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            handleAdd(index,row){
                if(!row.stock){
                    this.$message.error('此药品库存不足')
                    return;
                }
                this.$prompt('请输入此药品数量', '药品数量', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern:/^[1-9]\d*$/,
                    inputErrorMessage:'添加数量不能为零',
                    inputType:'number'
                }).then(({ value }) => {
                    var data={
                        name:row.name,
                        waresDrugNumber:value,
                        waresDrugCode:row.waresDrugCode
                    }
                    this.$emit("getTable",data);
                    this.getList()
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });       
                });
            },
            getList(){
                var waresTypeDrugCode=this.waresTypeDrugCode;
                if(!waresTypeDrugCode){
                    waresTypeDrugCode='00000000-0000-0000-0000-000000000000'
                }
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"WaresDrug/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        waresTypeDrugCode:waresTypeDrugCode,
                        supplierDrugCode:'00000000-0000-0000-0000-000000000000',
                        warehouseDrugCode:'00000000-0000-0000-0000-000000000000',
                        name:this.name,
                        status:0,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.tableData = this.getData(response.data.data.list);
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            getData(data){
                var waresDrugInfoAdd=this.codeList;
                for(var i in data){
                    if(waresDrugInfoAdd){
                        if(waresDrugInfoAdd.indexOf(data[i].waresDrugCode)>-1){
                            data[i].add=1
                        }else{
                            data[i].add=0
                        }
                    }else{
                        data[i].add=0
                    }
                }
                return data
            }

        }
    }
</script>

<style  lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

    .modal {
        background-color: #fff;
        box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        overflow-x:auto;
        display: flex;
        flex-direction: column;
        border-radius: 10px;
        width:1000px;

    .modal-header {
        border-bottom: 1px solid #eee;
        color: #313131;
        justify-content: space-between;
        padding: 10px;
        display: flex;
    }
    .modal-body {
        position: relative;
        padding: 20px 20px 0;
        z-index: 99;
        height: 100%;
    }
    .modal-footer {
        border-top: 1px solid #eee;
        justify-content: flex-end;
        padding: 15px;
        display: flex;
    }


    }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }
</style>